export const getBase64 = (img: Blob): Promise<string> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.addEventListener('load', () => {
            
            if(reader.result)
            {
                if(typeof reader.result == "string")
                {
                    console.log("reader.result(string)", reader.result);
                    resolve(reader.result)
                } else {
                    console.log("reader.result(arraybuf)", reader.result)
                    try {
                     let base64 = btoa(
                        new Uint8Array(reader.result)
                          .reduce((data, byte) => data + String.fromCharCode(byte), '')
                      );
                      resolve(base64);
                    } catch (err)
                    {
                        reject("");
                    }
                }
            } else {
                resolve("");// null
            } 
        });
        reader.readAsDataURL(img);
    })

}

export const base64ToString = (b64:string):string => {
    let s = atob(b64).toString();
    return s;
}

export const stringToBase64 = (str:string):string => {
    try {
    return btoa(str);
    } catch (err) {
        console.log("unexpected error (binary file)", err);
        return "";
    }
}

export function getImageFileFromBase64(string64:string, fileName:string) {
    let mime = 'image/png';
    let payload = string64;

    const dataUriMatch = string64.match(/^data:(image\/[a-zA-Z0-9.+-]+);base64,(.*)$/);
    if (dataUriMatch) {
        mime = dataUriMatch[1];
        payload = dataUriMatch[2];
    }

    const imageContent = atob(payload);
    const buffer = new ArrayBuffer(imageContent.length);
    const view = new Uint8Array(buffer);
  
    for (let n = 0; n < imageContent.length; n++) {
      view[n] = imageContent.charCodeAt(n);
    }
    const blob = new Blob([buffer], { type: mime });
    return new File([blob], fileName, { lastModified: new Date().getTime(), type: mime });
}

export const isDataUrl = (str:string): boolean => {
    return str.startsWith("data:");
}
